import { render } from "./NavigationProjectsComponent.vue?vue&type=template&id=4636fdd7"
import script from "./NavigationProjectsComponent.vue?vue&type=script&lang=js"
export * from "./NavigationProjectsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__